import gql from 'graphql-tag';

export const CreateSensorMutation = gql`
mutation createSensor(
  $name: String
  $room: String
  $lightsOnHighTemp: Float!
  $lightsOnLowTemp: Float!
  $lightsOffHighTemp: Float!
  $lightsOffLowTemp: Float!
  $tempTransitionPeriodLength: String!
  $luxLightsOnTarget: Float!
  $luxLightsOffTarget: Float!
  $luxThreshold: Float!
  $lightsOn: String!
  $lightsOff: String!
){
  createSensor(        
      name: $name
      room: $room
      lightsOnHighTemp: $lightsOnHighTemp
      lightsOnLowTemp: $lightsOnLowTemp
      lightsOffHighTemp: $lightsOffHighTemp
      lightsOffLowTemp: $lightsOffLowTemp
      tempTransitionPeriodLength: $tempTransitionPeriodLength
      luxLightsOnTarget: $luxLightsOnTarget
      luxLightsOffTarget: $luxLightsOffTarget
      luxThreshold: $luxThreshold
      lightsOn: $lightsOn
      lightsOff: $lightsOff
  ){
      name
      room
      lightsOnHighTemp
      lightsOnLowTemp
      lightsOffHighTemp
      lightsOffLowTemp
      tempTransitionPeriodLength
      luxLightsOnTarget
      luxLightsOffTarget
      luxThreshold
      lightsOn
      lightsOff
  }
}
`;

export default {
  CreateSensorMutation
};



// WEBPACK FOOTER //
// ./src/mutations/index.js